import GeneralHelper from '../../00_utilities/helpers/GeneralHelper';
import BreakpointHelper from '../../00_utilities/helpers/BreakpointHelper';
import AccessibilityHelper from '../../00_utilities/helpers/AccessibilityHelper';

class Navigation {
    constructor(elem) {
        this.elem = elem;
        this.breakpoints = {
            'main-navigation-breakpoint': 1260,
        };
        this.mainToggle = document.getElementById('main-menu-toggle');
        this.layoutDesktop = BreakpointHelper.aboveBreakpoint(this.breakpoints['main-navigation-breakpoint']);
        this.transition = window.getComputedStyle(this.elem).getPropertyValue('--navigation-transition');
    }

    init() {
        // workaround for mobiles not respecting 100vh properly
        this.elem.style.setProperty('--window-inner-height', `${window.innerHeight}px`);

        AccessibilityHelper.addAndHandleLabelsToggle('checkbox', this.mainToggle);

        this.calculateSubmenuOffset();
        this.behaviourOnChange();
        this.initResizeSensibleFunctions();
    }

    calculateSubmenuOffset() {
        for (const submenu of this.elem.querySelectorAll('.navigation__sub-menu')) {
            const parentNavItem = submenu.closest('.navigation__item');

            if (this.layoutDesktop) {
                const offset = parentNavItem.offsetLeft;
                parentNavItem.style.setProperty('--navigation-sub-offset', `${offset}px`);
            }

            const height = submenu.scrollHeight;
            parentNavItem.style.setProperty('--sub-menu-height', `${height}px`);
        }
    }

    initResizeSensibleFunctions() {
        // prevent transition issue on resize to below breakpoint
        const mediaQuery = window.matchMedia(`(min-width: ${this.breakpoints['main-navigation-breakpoint']}px)`);

        mediaQuery.addEventListener('change', (event) => {
            Navigation.closeNavigation();
            AccessibilityHelper.addAndHandleLabelsToggle('checkbox', this.mainToggle);
            this.layoutDesktop = event.matches;

            if (!event.matches) {
                this.elem.style.setProperty('--navigation-transition', 'none');

                setTimeout(() => {
                    this.elem.style.setProperty('--navigation-transition', this.transition);
                }, 300);
            }
        });

        // resize handling
        window.addEventListener('resize', GeneralHelper.throttle(() => {
            this.elem.style.setProperty('--window-inner-height', `${window.innerHeight}px`);
            this.calculateSubmenuOffset();
        }, 100));
    }

    behaviourOnChange() {
        const mainToggleHandling = (event) => {
            if (this.mainToggle.checked) {
                this.closeChildren(this.elem.querySelector('.navigation__main'));
                Navigation.preventScrolling();
                return;
            }

            this.closeChildren(event.currentTarget);
            Navigation.allowScrolling();
        };
        this.mainToggle.addEventListener('change', mainToggleHandling, false);

        const toggleInputs = this.elem.querySelectorAll('.navigation__menu-toggle-input');
        for (const toggle of toggleInputs) {
            toggle.addEventListener('change', (event) => {
                const { checked } = event.currentTarget;

                if (event.currentTarget.parentNode.classList.contains('navigation__item--main') && this.layoutDesktop) {
                    Navigation.allowScrolling();
                    if (checked) {
                        Navigation.preventScrolling();
                        this.closeBurgerMenu();
                    }
                }

                if (checked) {
                    this.closeSiblings(event.currentTarget);
                    return;
                }

                this.closeChildren(event.currentTarget);
            });
        }
    }

    static preventScrolling(element = 'body') {
        window.requestAnimationFrame(() => {
            document.querySelector(element).classList.add('no-scroll');
        });
    }

    static allowScrolling(element = 'body') {
        window.requestAnimationFrame(() => {
            document.querySelector(element).classList.remove('no-scroll');
        });
    }

    static checkboxHelper(checkbox, check, triggerChange) {
        if (typeof checkbox.prop === 'undefined') {
            checkbox.checked = check;

            if (triggerChange) {
                const event = new Event('change');
                checkbox.dispatchEvent(event);
            }
            return;
        }
        checkbox
            .prop('checked', check)
            .attr('checked', check);
        if (triggerChange) {
            checkbox.trigger('change');
        }
    }

    static closeNavigation() {
        const mainToggle = document.getElementById('main-menu-toggle');
        Navigation.checkboxHelper(mainToggle, false, true);

        const navigationToggleCheckboxes = document.querySelectorAll('.page-header .navigation [type="checkbox"]');
        for (const checkbox of navigationToggleCheckboxes) {
            Navigation.checkboxHelper(checkbox, false, true);
        }
        Navigation.allowScrolling();
    }

    closeBurgerMenu() {
        const mainToggle = document.getElementById('main-menu-toggle');
        Navigation.checkboxHelper(mainToggle, false);

        this.closeChildren(this.elem.querySelector('.navigation__wrapper.navigation__megadropdown > ul'));
    }

    getSiblings(element) {
        return Array.prototype.filter.call(element.parentNode.children, (sibling) => {
            return sibling !== element;
        });
    }

    closeSiblings(current) {
        let currentMenu = this.elem;

        if (current.id !== 'main-menu-toggle') {
            currentMenu = current;

            if (current.type === 'checkbox') {
                currentMenu = current.parentNode;
            }
        }

        const menuSiblings = this.getSiblings(currentMenu);

        for (const sibling of menuSiblings) {
            const siblingsToggle = sibling.querySelector('.navigation__menu-toggle-input');
            if (siblingsToggle) {
                Navigation.checkboxHelper(siblingsToggle, false);
            }
        }
    }

    closeChildren(current) {
        let currentMenu = this.elem;

        if (current.id !== 'main-menu-toggle') {
            currentMenu = current.parentNode;
        }

        const menuChildren = currentMenu.querySelectorAll('.navigation__has-children');
        for (const sibling of menuChildren) {
            const siblingsToggle = sibling.querySelector('.navigation__menu-toggle-input');
            if (siblingsToggle) {
                Navigation.checkboxHelper(siblingsToggle, false);
            }
        }
    }
}

export default Navigation;
